import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { applyPolyfills, defineCustomElements } from '@rccl/royal-payway/loader';
import { defineCustomElements as defineCustomElementsSharedComponents } from '@rccl/shared-components-web/loader';

if (environment?.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

applyPolyfills().then(() => {
  defineCustomElements(window);
});

defineCustomElementsSharedComponents(window);
